export const environment = {
  production: false,
  version: '0.5.88',
  mockApi: false,
  useKeycloak: true,
  apiBaseUrl: '/api',
  grafanaUrl: 'http://localhost:3000',
  keycloak: {
    url: 'http://localhost:8180',
    realm: 'drivelog',
    clientId: 'drivelog-frontend',
  },
};
